"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _contentType = require("@insided/shared/utils/contentType");

var _topicService = require("../services/topicService");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textField = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-field"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getSuccessMessage(multipleReplies, topic) {
  var _topic$url;

  var topicUrl = "".concat(window.location.origin).concat((_topic$url = topic.url) === null || _topic$url === void 0 ? void 0 : _topic$url.split('.com')[1]);
  var topicLink = "<a href=\"".concat(topicUrl, "\">").concat(topic.title, "</a>");
  return "The ".concat(multipleReplies ? 'replies have' : 'reply has', " been successfully moved to ").concat(topicLink);
}

var MoveToExistingTopicModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(MoveToExistingTopicModal, _PureComponent);

  var _super = _createSuper(MoveToExistingTopicModal);

  function MoveToExistingTopicModal() {
    var _this;

    (0, _classCallCheck2.default)(this, MoveToExistingTopicModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      isUrlValid: false,
      topic: null,
      error: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkUrl", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(topicUrl) {
        var _this$props, publicId, contentType, visibleReplyCount, topic, error;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, publicId = _this$props.publicId, contentType = _this$props.contentType, visibleReplyCount = _this$props.visibleReplyCount;
                _context.prev = 1;
                _context.next = 4;
                return (0, _topicService.getTopicByUrl)(topicUrl);

              case 4:
                topic = _context.sent;
                error = null;

                if (publicId && topic && parseInt(publicId) === topic.threadid) {
                  error = 'Unable to move this content. Please make sure the origin and destination are not the same.';
                } else if (visibleReplyCount) {
                  error = "".concat(contentType, " with visible replies cannot be converted to a reply. Please first trash or move the replies and try again.");
                }

                _this.setState({
                  topic: {
                    id: topic.threadid,
                    title: topic.topictitle,
                    contentType: (0, _contentType.getConsistentContentType)(topic.contenttype),
                    url: topic.url
                  },
                  isUrlValid: true,
                  error: error
                });

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](1);

                _this.setState({
                  error: 'No topic found for this url, please try something else.',
                  isUrlValid: false,
                  topic: null
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 10]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveTopicToExistingTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _this$props2, contentType, topicId, onShowAlert, topic, privateId;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, contentType = _this$props2.contentType, topicId = _this$props2.topicId, onShowAlert = _this$props2.onShowAlert;
              topic = _this.state.topic;

              if (!(!topicId || !topic)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              _this.setState({
                isLoading: true
              });

              _context2.prev = 5;
              _context2.next = 8;
              return (0, _topicService.getPrivateId)(Number(topic.id));

            case 8:
              privateId = _context2.sent;
              _context2.next = 11;
              return (0, _topicService.moveTopicToExistingTopic)(contentType, topicId, privateId, topic.contentType);

            case 11:
              window.location.assign("".concat(window.location.origin, "/topic/show?tid=").concat(topic.id));
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](5);
              onShowAlert('error');

            case 17:
              _this.setState({
                isLoading: false,
                isUrlValid: false
              });

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[5, 14]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMoveReplyToExistingTopic", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var _this$props3, contentType, replyId, onShowAlert, onClose, selectedReplies, getReplies, setSelectedReplies, topic, replyIds, privateId;

      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this$props3 = _this.props, contentType = _this$props3.contentType, replyId = _this$props3.replyId, onShowAlert = _this$props3.onShowAlert, onClose = _this$props3.onClose, selectedReplies = _this$props3.selectedReplies, getReplies = _this$props3.getReplies, setSelectedReplies = _this$props3.setSelectedReplies;
              topic = _this.state.topic;
              replyIds = replyId ? [String(replyId)] : selectedReplies;

              if (!(!replyIds || !topic || typeof getReplies !== 'function')) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return");

            case 5:
              _this.setState({
                isLoading: true
              });

              _context4.prev = 6;
              _context4.next = 9;
              return (0, _topicService.getPrivateId)(Number(topic.id));

            case 9:
              privateId = _context4.sent;
              _context4.next = 12;
              return (0, _topicService.moveRepliesToExistingTopic)(contentType, replyIds, privateId, topic.contentType);

            case 12:
              onClose();
              onShowAlert('success', getSuccessMessage(replyIds.length > 1, topic));
              setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return getReplies();

                      case 2:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })), 500);

              if (!replyId && typeof setSelectedReplies === 'function') {
                setSelectedReplies([]);
              }

              _context4.next = 21;
              break;

            case 18:
              _context4.prev = 18;
              _context4.t0 = _context4["catch"](6);
              onShowAlert('error');

            case 21:
              _this.setState({
                isLoading: false
              });

            case 22:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 18]]);
    })));
    return _this;
  }

  (0, _createClass2.default)(MoveToExistingTopicModal, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          onClose = _this$props4.onClose,
          moveType = _this$props4.moveType,
          topicId = _this$props4.topicId;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          error = _this$state.error,
          topic = _this$state.topic,
          isUrlValid = _this$state.isUrlValid;
      return (0, _preact.h)(_modal.default, {
        onClose: onClose,
        isControl: true
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: moveType
      }), (0, _preact.h)(_modal.ModalBody, null, (0, _preact.h)(_inputUnit.default, {
        label: "Enter the link of the topic you want to move the comment to:",
        isControl: true,
        error: error !== null && error !== void 0 ? error : undefined
      }, (0, _preact.h)(_textField.default, {
        id: "move-to-topic",
        ariaLabel: "move-to-topic",
        name: "move-to-topic",
        isControl: true,
        placeholder: "http://",
        onKeyUp: this.checkUrl,
        type: "text"
      })), topic && isUrlValid && (0, _preact.h)("div", {
        className: "valid-url-message"
      }, (0, _preact.h)(_inputUnit.default, {
        label: "Topic: ".concat(topic.title, " ")
      }, (0, _preact.h)("div", null, "You are about to relocate this reply to the topic: ".concat(topic.title, ". The position of your post will be based on the date and time it was originally posted. Are you sure you want to do this?"))))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)(_Button.default, {
        title: moveType,
        variant: "primary",
        onClick: topicId ? this.onMoveTopicToExistingTopic : this.onMoveReplyToExistingTopic,
        isLoading: isLoading,
        disabled: !isUrlValid || !!error,
        size: "medium",
        "data-qa": moveType
      })));
    }
  }]);
  return MoveToExistingTopicModal;
}(_preactCompat.PureComponent);

var _default = MoveToExistingTopicModal;
exports.default = _default;